import React, { useEffect, useState } from 'react'
import { Container, Box, useTheme, useMediaQuery, Typography, TextField, Divider, Button } from '@mui/material'
import { doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore'
import { db } from '../firebase.js'
import AlertDialog from '../components/AlertDialog.js'

function UploadDocuments () {
  // Themeing
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))
  const pageStyle = {
    page: { height: matches ? 'calc(100vh - 56px)' : 'calc(100vh - 64px)' },
    textContainer: { m: 'auto', height: '90%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' },
    textBox: { height: '33%', flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'auto', justifyContent: 'flex-end' },
    inputContainer: { m: 'auto', display: 'flex', height: '10%', justifyContent: 'flex-end', alignItems: 'center' }
  }
  // State
  const [sip, setSIP] = useState('')
  const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false)

  useEffect(() => {
    const fetchSIP = async () => {
      try {
        const sipSnap = await getDoc(doc(db, 'simulation_documents', '2VrZpCYu01TyIpcvle7H'))
        const data = sipSnap.data()
        setSIP(data.sip)
      } catch (error) {
        console.error('Error fetching SIP:', error)
      }
    }
    fetchSIP()
  }, [])

  const handleUpdate = () => {
    setIsAlertDialogOpen(true)
  }

  const updateSIP = async (input) => {
    try {
      await updateDoc(doc(db, 'simulation_documents', '2VrZpCYu01TyIpcvle7H'), {
        // eslint-disable-next-line object-shorthand
        sip: sip,
        updatedAt: serverTimestamp()
      })
      setIsAlertDialogOpen(false)
    } catch (err) { console.error(err) }
  }

  return (
    <Container sx={ pageStyle.page }>
    <Box sx={ pageStyle.textContainer }>
        <Box sx={ pageStyle.textBox }>
        <Typography variant='h6'> SIP </Typography>
        <TextField
          multiline
          rows={30}
          fullWidth
          value={sip}
          onChange={(e) => {
            setSIP(e.target.value)
          }}
        > </TextField>
        <Divider></Divider>
        </Box>
    </Box>
    <Box sx={ pageStyle.inputContainer }>
    <Button variant="contained" size="medium" onClick={handleUpdate}>
                    Upload
                  </Button>
    </Box>
    <AlertDialog isOpen={isAlertDialogOpen} handleClose={() => { setIsAlertDialogOpen(false) }} handleAgree={updateSIP} dialogTitle={ 'Upload the SIP' } dialogContent={ 'Do you want to upload this Version of the SIP?'}></AlertDialog>
</Container>
  )
}

export default UploadDocuments
